import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
// import JobManagementTable from "./jobTable";
import { InfoBox } from '../designUi';
import { UserIconLarge } from '../UIElements/svg-icons';
import Roles from './Roles';
import PermittedUsers from './PermittedUsers';
import { UsersComponentProps } from '../../interface/users';
import UsersTopStats from './usersTopStats';
import GridUserRoles from './gridUserRoles';

const UserManagementContent = ({
  usersList,
  isLoading,
  paginationState,
  setPaginationState,
}: UsersComponentProps) => {
  const theme = useTheme();

  return (
    <Stack sx={{ padding: 2, marginTop: 70 }}>
      <UsersTopStats />
      <GridUserRoles
        usersList={usersList}
        isLoading={isLoading}
        paginationState={paginationState}
        setPaginationState={setPaginationState}
      />
    </Stack>
  );
};

export default UserManagementContent;
